<template>
    <div class="grid grid-cols-2 sm:grid-cols-1 relative mb-[30px]">
        <div class="flex flex-col mt-auto justify-between space-y-2" @mouseleave="currentHoverIndex = -1">
            <!-- Levels List -->
            <div v-for="(config, index) in configs" :key="index" class="relative" aria-disabled="true">
                <div
                    @mouseenter="currentHoverIndex = index"
                    
                    class="bgHover py-1 px-3 mt-auto cursor-pointer relative rounded-md flex items-center justify-between"
                    :style="{
                        background: `linear-gradient(270deg,#2a354b,rgba(42,53,75,0))`,
                    }"
                    :class="{
                        'current': level === getLevelCount(index),
                        'disabled': disabledClass
                    }"
                >
                    <div class="flex items-center justify-center">
                        <div
                            v-for="(item, i2) in config.pair"
                            class="rounded-full w-[14px] h-[14px] inline-flex border border-[#7a95cd] mx-[6px] bg-[#7a95cd] i2"
                            :key="i2"
                            :style="{
                                backgroundColor: getPairColor(i2, getLevelCount(index)),
                                borderColor: getPairColor(i2, getLevelCount(index)),
                            }"
                        ></div>

                        <div
                            v-for="(item2, i3) in config.pair2"
                            class="rounded-full w-[14px] h-[14px] inline-flex border border-[#445984] mx-[6px] bg-[#445984] i3"
                            :key="i3"
                            :style="{
                                backgroundColor: getPairColor2(i3, getLevelCount(index)),
                                borderColor: getPairColor2(i3, getLevelCount(index)),
                            }"
                        />
                        <div
                            v-for="(item3, i4) in 5 - (config.pair + config.pair2)"
                            :key="i4"
                            class="rounded-full w-[14px] h-[14px] inline-flex border border-[#546892] mx-[6px] i4"
                        />
                    </div>

                    <span class="font-semibold">{{ config.mutiplier.toFixed(2) }}x</span>
                </div>
                <!-- Tips -->
                <div
                    v-if="
                        index === currentHoverIndex || (currentHoverIndex === -1 && level === getLevelCount(index))
                    "
                    class="flex sm:hidden gap-2 absolute top-1/2 bg-[#2a354b] p-[3px_13px_9px] rounded-md left-[calc(100%+25px)] translate-y-[-50%] max-w-[285px] w-full details"
                >
                    <div class="flex flex-col flex-1">
                        <p class="text-[9px] mb-[1rem] text-[#7186ae]">{{ t.payout }}</p>
                        <div
                            class="inline-flex rounded-md bg-[#354465FF] items-center min-w-[110px] px-2 py-[6px] relative"
                        >
                            <CurrentCoin size="12px" />
                            <div class="font-semibold ml-[0.5em]">
                                <span>{{
                                    Number(removeTrailingZeros(String(amount * config.mutiplier))).toFixed(2)
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col flex-1">
                        <p class="text-[9px] mb-[1rem] text-[#7186ae]">{{ t.chance }}</p>
                        <div
                            class="flex font-semibold justify-between gap-2 rounded-md bg-[#354465FF] items-center min-w-[110px] px-2 py-[6px] relative"
                        >
                            <span>{{ config.chance.toFixed(2) }}</span>
                            <span>%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { showTips4BadAmountIfNeeded } from '~/common/js/betHelper';
import useTranslation from '~/i18n/useTransLation';
import { colors } from '~/pages/casino/cryptosGame/datas';

const t = useTranslation();
const currentHoverIndex = ref(-1);
// clientWidth小于621时 hover时背景色不发生变化
const disabledClass = ref(false);

const props = defineProps({
    configs: {
        type: Array as PropType<Array<{ mutiplier: number; pair: number; pair2: number, chance: number }>>,
        required: true,
    },
    amount: {
        type: Number,
        required: true,
    },
    roll_number: {
        type: Array,
        required: true,
    },
    level: {
        type: Number,
        required: true,
    },
    frequencies: {
        type: Object,
        required: true,
    },
});

const getLevelCount = (index) => {
    return props.configs.length - 1 - index;
};
const getPairColor = (index: number, levelIndex: number) => {
    if (props.level === levelIndex) {
        return winColors.value[0];
    }
};
const getPairColor2 = (index: number, levelIndex: number) => {
    if (props.level === levelIndex) {
        return winColors.value[1];
    }
};
const handleResize = () => {
    if (document.body.clientWidth < 621){
        disabledClass.value = true;
    } else {
        disabledClass.value = false;
    }
}
// 设置赢分对应的颜色
const winColors = computed(() => {
    const array = Object.values(props.frequencies).sort((a, b) => b - a);
    const result = [];
    for (const item in props.frequencies) {
        if (array.includes(props.frequencies[item])) {
            result.unshift(colors[item]);
        }
    }

    return result;
});

watch([props],(val) =>{
    const level = val[0].level
    const config = val[0].configs
    // 计算需要的索引
    const indexToselect = config?.length -1 -(level+1)
    if(indexToselect >=0 && indexToselect<config.length){
        const diceMaxWin = Number(props.amount.beFixed(2)) * Number(config[indexToselect].mutiplier)
        // ↓ 调取 查询当前游戏当前币种最大赔付金额
        showTips4BadAmountIfNeeded(diceMaxWin)
    }
});

onMounted(() => {
    handleResize();
    window.addEventListener('resize', handleResize)
});
onUnmounted(() => {
    window.removeEventListener('resize', handleResize)
})
</script>
<style scoped lang="scss">
.details::before {
    border-color: transparent #2a354b transparent transparent;
    border-style: solid;
    border-width: 6px 8px 6px 0;
    content: '';
    height: 0;
    margin-top: -6px;
    right: 100%;
    width: 0;
    position: absolute;
    top: 50%;
}
.current, .bgHover:hover:not(.disabled) {
    background: linear-gradient(270deg, #435578, #2b364e) !important;
}
</style>
